module.exports = __webpack_public_path__ + "media/images/pension_number-66c79c74f25c257f435e138877fa6955.png";